import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    CellRunner,
    JockeyAndTrainerDetailsBox,
    RaceSummaryRow,
    SilkCellRaceSummaryWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/extraPlacesSummary/RaceSummaryRowExtraPlaces.style';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    selectionId: SelectionId;
    isNonRunner?: boolean;
}

export const RaceSummaryRowExtraPlaces = observer('RaceSummaryRowExtraPlaces', (props: PropsType) => {
    const { selectionId, isNonRunner } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const silkUrl = selectionModel.metaDataSilkUrl ?? '';
    const silkAltDesc = selectionModel.metaDataSilk ?? 'Silk image';

    return (
        <RaceSummaryRow
            isNonRunner={isNonRunner}
            variant={configState.componentVariants.sportsbookVariant}
        >
            <CellRunner>
                <SilkCellRaceSummaryWrapper>
                    <LazyImageSilk
                        imgBase={{
                            src: silkUrl,
                            optimizeOptions: {
                                quality: 85,
                                width: 54,
                            },
                        }}
                        alt={silkAltDesc}
                    />
                </SilkCellRaceSummaryWrapper>

                <JockeyAndTrainerDetailsBox
                    selectionId={selectionId}
                    isDetailsAvailable={true}
                />
            </CellRunner>
        </RaceSummaryRow>
    );
});
